import Action from '../../classes/Action';
import {ActionDescription, ActionParameters}   from '../../classes/api/APIDecorators';
import Engine from "../../classes/Engine";
import DefaultSceneManager from "../../classes/DefaultSceneManager";
import { CustomEventTypes } from "../../globals";
import Sequence from '../../classes/scenarioElements/Sequence';
import Step from '../../classes/scenarioElements/Step';
import Scenario from '../../classes/scenarioElements/Scenario';

@ActionDescription("Adds a step to a sequence. IMPORTANT: make sure (a) the step's name is unique in the sequence, and (b) the name is not 'Content Placement'. Returns void.")
@ActionParameters({sequence: "Sequence", step: "Step", index: "number"})
export default class AddStepAction extends Action
{
	constructor(sequence: Sequence, step: Step, index = -1)
	{
		const previousStep = Scenario.currentStep();
		const previousSelection = Engine.getInstance().getPickingManager().getCurrentSelection();
		super(
			[sequence, step, previousStep, previousSelection, index],
			[sequence, step, previousSelection],
			"Added step '" + step.name + "' to sequence '" + sequence.name + "'",
			[sequence, step, previousStep]
		);
	}

	do(sequence: Sequence, step: Step, previousStep: Step, previousSelection, index)
	{
		Scenario.addStep(sequence, step);
		Scenario.setCurrentStep(step);

		if (index >= 0)
		{
			step.index = index;
		}

		const sceneId = step.sceneId;
		if (previousSelection.groupGuid)
		{
			Engine.getInstance().getPickingManager().selectGroup(previousSelection.groupGuid, sceneId);
			document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
		}
		else if (previousStep.connectedToDefault || previousStep.isDefault())
		{
			DefaultSceneManager.getInstance().selectParallalObjects(previousSelection.objects, sceneId);
		}
		else
		{
			Engine.getInstance().getPickingManager().clearSelection();
		}
		Engine.getInstance().getPickingManager().storeSelection();
		document.dispatchEvent(new CustomEvent(CustomEventTypes.onElementNameChanged)); // will update text variables
	}

	undo(sequence: Sequence, step: Step, previousSelection)
	{
		Scenario.removeStep(sequence, step);
		Engine.getInstance().getPickingManager().restoreSelection(previousSelection);
		document.dispatchEvent(new CustomEvent(CustomEventTypes.onElementNameChanged)); // will update text variables
	}

	verify(sequence: Sequence, step: Step)
	{
		if (!sequence || !step || step.isTrackersStep())
		{
			return false;
		}

		return sequence.steps.indexOf(step) < 0;
	}
}
